import { useMemo } from "react";
import { resolveRightPanelResourceLabels } from "../components/rightPanelResourceLabels";
import { resolveBrowserPreviewSidebarLabel } from "./-chatThreadRoute.logic";

export function useThreadResourceLabels(input: {
  readonly browserThreadState: Parameters<
    typeof resolveBrowserPreviewSidebarLabel
  >[0]["browserThreadState"];
  readonly previewTabId: string | undefined;
  readonly surfaces: Parameters<typeof resolveRightPanelResourceLabels>[0]["surfaces"];
  readonly activeSurfaceId: string | null;
}): Readonly<Record<string, string>> {
  const { browserThreadState, previewTabId, surfaces, activeSurfaceId } = input;
  const activeLabel = useMemo(
    () => resolveBrowserPreviewSidebarLabel({ browserThreadState, previewTabId }),
    [browserThreadState, previewTabId],
  );
  return useMemo(
    () => resolveRightPanelResourceLabels({ surfaces, activeSurfaceId, activeLabel }),
    [activeLabel, activeSurfaceId, surfaces],
  );
}
